module.exports = __webpack_public_path__ + "img/vaccine_record_cancel.fd238ce5.png";